<div class="fuse-vertical-navigation-wrapper">
  <!-- Header -->
  <div class="fuse-vertical-navigation-header">
    <ng-content select="[fuseVerticalNavigationHeader]"></ng-content>
  </div>

  <!-- Content -->
  <div
    class="fuse-vertical-navigation-content"
    fuseScrollbar
    [fuseScrollbarOptions]="{ wheelPropagation: inner, suppressScrollX: true }"
    #navigationContent
  >
    <!-- Content header -->
    <div class="fuse-vertical-navigation-content-header">
      <ng-content select="[fuseVerticalNavigationContentHeader]"></ng-content>
    </div>

    <!-- Items -->
    @for (item of navigation; track trackByFn($index, item)) {
      @if (!item.hidden && !item.footer) {
        <ng-container *ngTemplateOutlet="navItem; context: { $implicit: item }"></ng-container>
      }
    }

    <!-- Content footer -->
    <div class="fuse-vertical-navigation-content-footer">
      <ng-content select="[fuseVerticalNavigationContentFooter]"></ng-content>
    </div>
  </div>

  <!-- Footer -->
  <div class="fuse-vertical-navigation-footer">
    @for (item of navigation; track trackByFn($index, item)) {
      @if (!item.hidden && item.footer) {
        <ng-container *ngTemplateOutlet="navItem; context: { $implicit: item }"></ng-container>
      }
    }

    <ng-content select="[fuseVerticalNavigationFooter]"></ng-content>
  </div>
</div>

<!-- Item type switch (shared by content and footer loops) -->
<ng-template #navItem let-item>
  @if (item.type === 'aside') {
    <fuse-vertical-navigation-aside-item
      [item]="item"
      [name]="name"
      [attr.data-test]="'nav-item-' + item.id"
      [activeItemId]="activeAsideItemId"
      [autoCollapse]="autoCollapse"
      [skipChildren]="true"
      (click)="toggleAside(item)"
    ></fuse-vertical-navigation-aside-item>
  }
  @if (item.type === 'basic') {
    <fuse-vertical-navigation-basic-item
      [item]="item"
      [name]="name"
      [attr.data-test]="'nav-item-' + item.id"
    ></fuse-vertical-navigation-basic-item>
  }
  @if (item.type === 'collapsable') {
    <fuse-vertical-navigation-collapsable-item
      [item]="item"
      [name]="name"
      [autoCollapse]="autoCollapse"
      [attr.data-test]="'nav-item-' + item.id"
    ></fuse-vertical-navigation-collapsable-item>
  }
  @if (item.type === 'divider') {
    <fuse-vertical-navigation-divider-item
      [item]="item"
      [name]="name"
      [attr.data-test]="'nav-item-' + item.id"
    ></fuse-vertical-navigation-divider-item>
  }
  @if (item.type === 'group') {
    <fuse-vertical-navigation-group-item
      [item]="item"
      [name]="name"
      [autoCollapse]="autoCollapse"
      [attr.data-test]="'nav-item-' + item.id"
    ></fuse-vertical-navigation-group-item>
  }
  @if (item.type === 'spacer') {
    <fuse-vertical-navigation-spacer-item
      [item]="item"
      [name]="name"
      [attr.data-test]="'nav-item-' + item.id"
    ></fuse-vertical-navigation-spacer-item>
  }
</ng-template>

<!-- Aside -->
@if (activeAsideItemId) {
  <div
    class="fuse-vertical-navigation-aside-wrapper"
    fuseScrollbar
    [fuseScrollbarOptions]="{ wheelPropagation: false, suppressScrollX: true }"
    [@fadeInLeft]="position === 'left'"
    [@fadeInRight]="position === 'right'"
    [@fadeOutLeft]="position === 'left'"
    [@fadeOutRight]="position === 'right'"
  >
    <!-- Items -->
    @for (item of navigation; track trackByFn($index, item)) {
      <!-- Skip the hidden items -->
      @if (!item.hidden) {
        <!-- Aside -->
        @if (item.type === 'aside' && item.id === activeAsideItemId) {
          <fuse-vertical-navigation-aside-item
            [item]="item"
            [name]="name"
            [autoCollapse]="autoCollapse"
          ></fuse-vertical-navigation-aside-item>
        }
      }
    }
  </div>
}
